<template>
  <v-dialog
    v-model="show"
    :persistent="options.persistent"
    :max-width="options.maxWidth"
    fullscreen
    scrollable
  >

    <v-card flat>
      <v-layout
        style="margin-top:5%"
        row
        justify-center
      >
        <v-card flat>
          <branding-header-card />

          <v-layout
            justify-center
            row
          >
            <v-layout column>
              <v-layout
                class="ma-3"
                justify-center
                row
              >
                <span style="font-weight:700;">SESSION TIMEOUT</span>
              </v-layout>
              <span
                class="mb-4 mx-3"
                style="max-width:400px;"
              >For security purposes you will be logged out shortly due to inactivity. Please choose to stay signed in or to log out. Otherwise, you will be logged out automatically.</span>
            </v-layout>
          </v-layout>

          <v-card-text>
            <div class="content">You will be logged out shortly. Do you want to stay signed in?</div>
          </v-card-text>

          <v-card-actions>
            <v-layout column>
              <v-btn
                flat
                color="primary"
                @click="ok()"
              >Sign me out</v-btn>
              <v-btn
                depressed
                dark
                color="primary"
                @click="cancel()"
              >Keep me signed in</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-card>

  </v-dialog>
</template>

<style scoped>
.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: white;
  margin-left: 30px;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #52535f;
  padding: 18px 15px;
  font-weight: bold;
}

.footer {
  border-top: 1px solid #e0e0e0;
}
</style>

<script>
import DialogMixin from '@/core/mixins/DialogMixin'
import BrandingHeaderCard from '@/components/cards/BrandingHeaderCard'

export default {
  components: {
    BrandingHeaderCard
  },
  name: 'IdleDialog',
  mixins: [DialogMixin],
  data() {
    return {
      timer: null,
      seconds: 60,
      className: 'Confirm',
      defaultOptions: {
        okLabel: 'Confirm'
      }
    }
  },
  methods: {
    countdown() {
      this.seconds--
      if (this.seconds <= 0) {
        this.ok()
      }
    },
    onOpen() {
      this.seconds = 60
      if (!this.timer) {
        this.timer = window.setInterval(this.countdown, 1000)
      }
    },
    onClose() {
      if (this.timer) {
        window.clearInterval(this.timer)
      }
      this.timer = null
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
    this.$on('close', this.onClose)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/IdleDialog.vue